import axios from 'axios';
import { getAccessToken } from './tokenProvider';
import { signOutFrontend } from './authUtils';
import { toast } from 'react-toastify';

const API_BASE_URL = process.env.REACT_APP_API_URL;

const apiClient = axios.create({
  baseURL: `${API_BASE_URL}/api/v1`,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

// Add access token to all requests
apiClient.interceptors.request.use(async (config) => {
  const token = await getAccessToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Unwrap response data; central 401 and 403 handling
apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    
    // Don't treat aborted requests as errors
    if (error.code === 'ERR_CANCELED' || axios.isCancel(error)) {
      return;
    }
    if (!error.response) {
      const isOnline = navigator.onLine;
      if (!isOnline) {
        toast.error('You appear to be offline. Please check your internet connection.');
      } else {
        toast.error('Unable to reach server. Please try again.');
      }
      return Promise.reject(error);
    }

    // Central 401 handling: sign out for any auth failure
    if (error.response?.status === 401) {
      const msg = error.response?.data?.error || 'Session expired';
      toast.error(msg);
      signOutFrontend();
      return Promise.reject(error);
    }

    // Central handling for CanCan authorization 403 only (error === "access_denied")
    // Other 403s are left to components.
    const isAccessDenied = error.response?.status === 403 && error.response?.data?.error === 'access_denied';
    if (isAccessDenied) {
      const msg = error.response?.data?.message || 'Access denied';
      toast.error(msg);
    }

    return Promise.reject(error);
  }
);

export default apiClient;